export enum ELanguage {
  ENGLISH = 'en',
  GERMAN = 'de',
  ITALIAN = 'it',
  SPANISH = 'es',
  ARABIC = 'ar',
}
